export const documentKeys = {
    all: ['documents'] as const,
    lists: (customerId: string) => [...documentKeys.all, customerId, 'list'] as const,
    list: (customerId: string, filters: Record<string, unknown> = {}) =>
        [...documentKeys.lists(customerId), filters] as const,
}
